import React, { PropsWithChildren, ReactNode } from 'react';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { Exception } from 'src/shared/ui/exception';
import { SupportCode } from 'src/shared/supportCode';

export interface ModalErrorBoundaryProps extends PropsWithChildren {
  fallbackAction?: ReactNode;
}
export class ModalErrorBoundary extends React.Component<ModalErrorBoundaryProps, { error: Error | null }> {
  constructor(props: ModalErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  render() {
    if (this.state.error) {
      return (
        <ModalLayout>
          <ModalContainer>
            <Exception error={this.state.error} nextAction={this.props.fallbackAction}>
              <SupportCode sx={{ textAlign: 'center' }} />
            </Exception>
          </ModalContainer>
        </ModalLayout>
      );
    }
    return this.props.children;
  }

  componentDidCatch() {
    //
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }
}
